exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-invite-form .field.has-addons[data-v-2f7d6274] {\n  flex: 0 48%;\n}\n.user-invite-form .field.has-addons .user-email-input[data-v-2f7d6274] {\n  flex: 0 100%;\n}", ""]);

// exports
